import { getPlans } from './getPlans'

export const Plans = {
    getPlans,
}
